import React from "react";

import {Polygon, FeatureGroup, Tooltip} from "react-leaflet";


const defaultPathOptions = {
    color: '#7b809a',
    weight: 1,
}

const selectedPathOptions = {
    weight: 1,
    color: '#e91e63',
}


const renderPropertyId = (feature) => {
    const {properties} = feature;
    return properties?.id
}

const GeoJSONMultiPolygonCollection = ({
                                           featureCollection,
                                           polygonKeyFn = null,
                                           getSelectedFeatures = null,
                                           onFeatureClick = f => f,
                                           colorByFeature = null,
                                           renderFeatureTooltip = renderPropertyId
                                       }) => {
    const features = featureCollection?.features ?? [];

    const [selected, other] = getSelectedFeatures ? getSelectedFeatures(features) : [[], features];

    const handleMouseOver = (e) => {
        e.target.setStyle({
            weight: 3,
            fillOpacity: 0.6
        });

        e.target.bringToFront();
    };

    const handleMouseOut = (e, currentPathOptions) => {
        const layer = e.target;
        layer.setStyle({
            weight: currentPathOptions.weight,
            color: currentPathOptions.color,
            fillOpacity: currentPathOptions.fillOpacity
        });

        e.target.bringToBack();
    };

    const handleMouseHoverSelected = (e) => {
        e.target.setStyle({weight: 3});
        e.target.bringToFront();
    }

    const handleMouseOutSelected = (e, currentPathOptions) => {
        const layer = e.target;
        layer.setStyle({
            weight: currentPathOptions.weight || 1,
            color: currentPathOptions.color,
            fillOpacity: currentPathOptions.fillOpacity
        });
        e.target.bringToBack();
    }

    const handleClick = (e, feature) => {
        onFeatureClick(feature);
    }

    const renderFeature = (feature, selected) => {
        const pathOptions = selected ?
            selectedPathOptions
            : {
                ...defaultPathOptions,
                color: colorByFeature ? colorByFeature(feature) : defaultPathOptions.color,
                fillOpacity: 0.4,
            }

        return <Polygon key={polygonKeyFn ? polygonKeyFn(feature) : feature.properties.id}
                        positions={feature.geometry.coordinates.map(polygon => polygon[0].map(([lon, lat]) => [lat, lon]))}
                        pathOptions={pathOptions}
                        eventHandlers={selected ?
                            {
                                mouseover: handleMouseHoverSelected,
                                mouseout: (e) => handleMouseOutSelected(e, pathOptions),
                                click: (e) => handleClick(e, feature),
                            }
                            :
                            {
                                mouseover: handleMouseOver,
                                mouseout: (e) => handleMouseOut(e, pathOptions),
                                click: (e) => handleClick(e, feature),
                            }
                        }
        >
            <Tooltip>{renderFeatureTooltip(feature)}</Tooltip>
        </Polygon>
    }

    return <FeatureGroup>
        {
            other.map(feature => renderFeature(feature, false))
        }
        {
            selected.map(feature => renderFeature(feature, true))
        }
    </FeatureGroup>
}


export default GeoJSONMultiPolygonCollection;